import { render, staticRenderFns } from "./CampaignProfile.vue?vue&type=template&id=1494f898&scoped=true&"
import script from "./CampaignProfile.vue?vue&type=script&lang=js&"
export * from "./CampaignProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1494f898",
  null
  
)

export default component.exports